import React from 'react';
import ReactDOMClient from 'react-dom/client';
import singleSpaReact from 'single-spa-react';
import { logger } from '@ecosystem/newron-client-lib';
import { Root } from './Root';
import { feedbackV2 } from '@ecosystem/newron-design-system';
import { COLLECTION_PATH, NOTIFICATIONS_PREFERENCES } from '@utils/UrlUtils';

const lifecycles = singleSpaReact({
  renderType: 'createRoot',
  React,
  ReactDOMClient,
  rootComponent: Root,
  errorBoundary(err: Error, info: React.ErrorInfo) {
    logger.error(err, {
      componentStack: info.componentStack,
    });
    const isCollectionOrNotification =
      location.pathname.startsWith(COLLECTION_PATH) || location.pathname.startsWith(NOTIFICATIONS_PREFERENCES);
    return (
      <>
        {!isCollectionOrNotification && (
          <div className="mx-32 my-16">
            <feedbackV2.Alert
              title={
                <>
                  The requested data for this page has failed to load.
                  <br /> Please refresh your browser to try again. If this issue persists, please contact your GfK
                  representative.
                </>
              }
              type="error"
            />
          </div>
        )}
      </>
    );
  },
});

export const { bootstrap, mount, unmount } = lifecycles;
